import React from 'react'
import {
    StyledProfileCard,
    StyledCardTextContainer,
    StyledCardText,
    StyledLink,
    StyledPremiumIcon,
} from './ProfileCard.styled'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import { CommonCardProps } from '../CardItem.Props'

import { toLinkWithHint } from '@news-mono/web-common'
import { CardMedia } from '../CardMedia/CardMedia'
import { PublicationCardItem } from '@news-mono/web-common'
import { createCardClickedEvent } from '@news-mono/web-common'
import {
    ResponsiveContainer,
    applyContainerRatio,
} from '../../content/Picture/responsive'
import { useTheme } from '@emotion/react'
import { requiredAccessValue } from '@news-mono/web-common'
import { KickerMode, IconTypes } from '../Kicker/Kicker'

export interface ProfileCardProps extends CommonCardProps, ResponsiveContainer {
    cardNumber: number
    innerRef?: React.RefObject<any>
    item: MaybeLoaded<PublicationCardItem>
    kickerMode?: KickerMode
    kickerIcons?: Array<IconTypes>
}

export const ProfileCard: React.FC<ProfileCardProps> = (props) => {
    const theme = useTheme()

    const linkClicked = (e: React.MouseEvent<HTMLElement>) => {
        if (!props.item.loaded) {
            // We don't want the link to do anything
            e.preventDefault()
            return
        }

        props.onEvent(
            createCardClickedEvent(
                props.item.result,
                'InternalProfileCard',
                'ProfileCard',
                props.cardNumber,
            ),
        )
    }

    const { item, onEvent } = props
    const requiredAccess = !item.loaded ? undefined : item.result.requiredAccess

    return (
        <StyledProfileCard>
            <StyledLink to={toLinkWithHint(item)} onClick={linkClicked}>
                {requiredAccessValue(requiredAccess, {
                    subscriber: <StyledPremiumIcon />,
                    anonymous: undefined,
                })}
                <CardMedia
                    item={item}
                    onEvent={onEvent}
                    mediaMode={'edgeToEdge'}
                    imageWidths={applyContainerRatio(
                        props.containerWidthRatios,
                        {
                            mobile: '100vw',
                            tablet: '100vw',
                            desktop: `${theme.siteMetrics.mainContentWidth}px`,
                            fallbackWidth: theme.siteMetrics.mainContentWidth,
                        },
                    )}
                />
                <StyledCardTextContainer>
                    <StyledCardText
                        fontScale={1}
                        item={item}
                        onEvent={onEvent}
                        teaserMode="hidden"
                        kickerMode={{
                            kickerType: 'block',
                            icons: props.kickerIcons ? props.kickerIcons : [],
                        }}
                    />
                </StyledCardTextContainer>
            </StyledLink>
        </StyledProfileCard>
    )
}
ProfileCard.displayName = 'ProfileCard'
